/* Functional Activator product page. Presentation only.

   NOTHING IN THIS FILE CHANGES THE LAYOUT OF THE BUY COLUMN AFTER FIRST PAINT.
   That is the whole rule it is written to. The price row, the size picker's head
   row, the size guide trigger, the saving pill and the green selected pill are all
   RENDERED by sections/main-product.liquid, so they are on the page, at their
   final size, in the first frame. Every earlier version of this file built one of
   them by moving or creating nodes once the page had loaded, and every one of them
   dropped the column in front of the shopper.

   What it does now, none of which changes layout outside a single control and none
   of which touches the purchase mechanism:
     1. orders the size options the way the size guide lists them, and gives each
        one its measurement, read from that guide rather than from a copy kept here
     2. rewrites the text of the already-rendered selected pill WHEN THE SHOPPER
        CHANGES THE SIZE
     3. gives the Featured Product section lower on the page the same size labels

   It never writes a value into the Activator's form, its variant id, its quantity,
   its Add to cart, its payment buttons, the cart or checkout. Option VALUES are
   never altered, only the text shown for them and the order they are listed in, so
   the variant the theme submits is unchanged. */
(function () {
  'use strict';

  /* The size guide already on the page is the single source for the size names,
     their measurements and the order they belong in. Editing the guide in the theme
     editor therefore keeps the picker in step, with no second copy to forget. */
  function readSizeGuide(root) {
    var order = [], measure = {};
    root.querySelectorAll('.ppro-sg table tr').forEach(function (tr) {
      var cells = tr.querySelectorAll('td, th');
      if (cells.length < 2) { return; }
      var name = cells[0].textContent.trim();
      var value = cells[1].textContent.trim();
      if (!name || !value || /^size$/i.test(name)) { return; }
      if (order.indexOf(name.toLowerCase()) === -1) { order.push(name.toLowerCase()); }
      measure[name.toLowerCase()] = value;
    });
    return { order: order, measure: measure };
  }

  function labelOptions(select, guide) {
    Array.prototype.forEach.call(select.options, function (opt) {
      var base = (opt.getAttribute('data-fa-pp-base') || opt.textContent).trim();
      opt.setAttribute('data-fa-pp-base', base);
      var m = guide.measure[base.toLowerCase()];
      opt.textContent = m ? base + ', ' + m : base;
    });
  }

  /* Reordering the option elements leaves the selection alone, because the browser
     tracks the selected OPTION rather than its index. Anything the guide does not
     name keeps its existing order and follows the ones it does. */
  function orderOptions(select, guide) {
    if (!guide.order.length) { return; }
    var opts = Array.prototype.slice.call(select.options);
    var rank = function (o) {
      /* A "-- Choose Option --" placeholder carries no value. It is not a size and
         it belongs at the top, so it is ranked before everything the guide names. */
      if (!o.value) { return -1; }
      var i = guide.order.indexOf((o.getAttribute('data-fa-pp-base') || o.textContent).trim().toLowerCase());
      return i === -1 ? guide.order.length + opts.indexOf(o) : i;
    };
    opts.slice().sort(function (a, b) { return rank(a) - rank(b); })
      .forEach(function (o) { select.appendChild(o); });
  }

  /* The price row, its saving pill and the head row are not built here.

     They were, and each one repainted the column after load: the row was lifted
     out of the buy buttons block, the saving was moved out of the compare-at <del>
     and reworded, and the data-fa-pp-saving attribute the green pill is drawn from
     was added by script, so until it arrived the saving was unpadded inline text
     and the row reflowed the moment it was styled.
     sections/main-product.liquid renders all of it, for this template only, with
     the final wording and the attribute already in place. There is nothing left
     here to lift, move, reword or style. */

  function init(root) {
    var picker = root.querySelector('.product-variants--select .product-variant');
    var select = picker && picker.querySelector('.product-variant-container');
    if (!picker || !select) { return; }

    var guide = readSizeGuide(root);
    labelOptions(select, guide);
    orderOptions(select, guide);

    /* NOTHING IN THIS COLUMN IS MOVED, CREATED OR RESTYLED AFTER PAINT.

       The head row, the size guide trigger, the price row, the saving pill and
       the green selected pill are all rendered by sections/main-product.liquid.
       Every one of them was once built here, after load, and every one of them
       dropped the column.

       What is left is the selected pill's TEXT. The pill is already on the page
       with the preselected size in it, so the first pass below writes the same
       words it already holds and moves nothing. After that it is only rewritten
       when the shopper changes the size, which is a one-line pill whose height
       does not depend on its words. */
    var label = picker.querySelector('.product-variant__name');
    var pill = root.querySelector('[data-fa-pp-selected]');

    function report() {
      var opt = select.options[select.selectedIndex];
      var name = opt ? (opt.getAttribute('data-fa-pp-base') || opt.textContent).trim() : '';
      var optionName = label ? label.textContent.trim() : 'Size';
      var short = optionName.split(/\s+/).pop();
      short = short.charAt(0).toUpperCase() + short.slice(1);
      if (pill) {
        if (name && !(opt && opt.disabled)) {
          var next = short + ' ' + name + ' selected';
          if (pill.textContent.trim() !== next) { pill.textContent = next; }
          pill.removeAttribute('hidden');
        } else {
          pill.setAttribute('hidden', '');
        }
      }
    }

    if (!select.hasAttribute('data-fa-pp-bound')) {
      select.setAttribute('data-fa-pp-bound', '');
      select.addEventListener('change', report);
      document.addEventListener('variant:change', report);
    }

    report();
  }

  /* The Featured Product section further down the page sells the same product with
     the theme's own picker. It gets the same size labels as the main picker, read
     from the same size guide, so the two can never disagree. Labels only: the order
     and every option VALUE are left alone, so its variant matching, its form and its
     payment buttons are untouched.

     Matched on the section's key in templates/product.functional-activator.json,
     featured_product_fa. Shopify prefixes the key with the template's own id, so the
     key is the stable end of the id. If the section is ever deleted and re-added in
     the theme editor it gets a new key, and this selector and the one in
     fa-product-page.css must be changed to match it. */
  function labelFeatured() {
    var main = document.querySelector('[data-fa-product-page]');
    if (!main) { return; }
    var guide = readSizeGuide(main);
    if (!guide.order.length) { return; }
    document.querySelectorAll('[id$="__featured_product_fa"] .product-variants--select .product-variant-container')
      .forEach(function (select) { labelOptions(select, guide); });
  }

  /* "How to measure" beside the Featured Product's size label, opening the same size
     guide as the main buy column. The link is copied from the main column's own
     trigger, so it carries that dialog's real id and wording and nothing is hard
     coded here. It is a plain button handled by component-size-guide.js like the
     main one: it reads and writes no form, variant, quantity, cart or checkout.
     The Featured Product sits at the foot of the page, far below the first screen,
     so adding it here moves nothing the shopper is looking at. Idempotent. */
  function featuredMeasure() {
    var main = document.querySelector('[data-fa-product-page]');
    var source = main && main.querySelector('.fa-pp__picker-head .ppro-sg-trigger-wrap');
    if (!source) { return; }
    document.querySelectorAll('[id$="__featured_product_fa"] .product-variants--select .product-variant').forEach(function (variant) {
      if (variant.querySelector('.ppro-sg-trigger-wrap')) { return; }
      var label = variant.querySelector('.product-variant__name');
      if (!label) { return; }
      label.insertAdjacentElement('afterend', source.cloneNode(true));
    });
  }

  function boot() {
    document.querySelectorAll('[data-fa-product-page]').forEach(init);
    labelFeatured();
    featuredMeasure();
  }
  document.addEventListener('variant:change', featuredMeasure);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Run again once the page has settled, because the size guide's table is what the
     measurements and the option order are read from and the app blocks around it
     arrive late. Both passes only relabel and reorder OPTIONS inside one select and
     rewrite one pill's text to what it already says, so a second pass cannot move
     the column. */
  window.addEventListener('load', boot);
})();
